import { makeApiCall } from '../_common/api.utils';
import { API_URL } from '../const';

/******************* GET DASHBOARD CARD DETAILS START *********** */
export const dashboardDetailsGet = (listData: any) => {
	const data = {
		GetDashboardCardDetailsToken: listData,
	};
	const url = `${API_URL}getDashboardCardDetails`;
	return makeApiCall(url, data);
};
/******************* GET DASHBOARD CARD DETAILS END *********** */

/******************* GET REJECT MEMBER LIST START *********** */
export const rejectMemberListCall = (listData: any) => {
	const data = {
		RejectedMembersDetailsToken: listData,
	};
	const url = `${API_URL}getRejectedMembersDetailsInfo`;
	return makeApiCall(url, data);
};
/******************* GET REJECT MEMBER LIST END *********** */

/******************* GET EOD LIST START *********** */
export const companyEodStatusGet = (listData: any) => {
	const data = {
		GetCompanyEndOfDayStatusToken: listData,
	};
	const url = `${API_URL}endOfDayStatusCompany`;
	return makeApiCall(url, data);
};
/******************* GET EOD LIST END *********** */

/******************* GET DASHBOARD LOAN TYPE START *********** */
export const dashboardDetailsLoanTypeGet = (listData: any) => {
	const data = {
		DashboardDetailsLoanTypeToken: listData,
	};
	const url = `${API_URL}getDashboardDetailsBasedonLoanType`;
	return makeApiCall(url, data);
};
/******************* GET DASHBOARD LOAN TYPE END *********** */

/******************* GET LOAN DETAILS START *********** */
export const loanDetailsGet = (listData: any) => {
	const data = {
		GetDashboardLoanDetailsToken: listData,
	};
	const url = `${API_URL}getDashboardLoanDetails`;
	return makeApiCall(url, data);
};
/******************* GET LOAN DETAILS END *********** */

/******************* GET LOAN INDEX DETAILS START *********** */
export const loanIndexDetailsGet = (listData: any) => {
	const data = {
		DashboardLoanIndexDetailsToken: listData,
	};
	const url = `${API_URL}getDashboardLoanIndexDetails`;
	return makeApiCall(url, data);
};
/******************* GET LOAN INDEX DETAILS END *********** */

/******************* GET DASHBOARD PARTICULAR LIST START *********** */
export const dashboardParticularListCall = (listData: any) => {
	const data = {
		DashboardCardBranchwiseToken: listData,
	};
	const url = `${API_URL}getDashboardCardBranchwise`;
	return makeApiCall(url, data);
};
/******************* GET DASHBOARD PARTICULAR LIST END *********** */

/******************* GET DASHBOARD STAFF COLLECTION LIST START *********** */
export const dashboardStaffCollectionListCall = (listData: any) => {
	const data = {
		StaffTotalcollectionToken: listData,
	};
	const url = `${API_URL}getDashboardStaffTotalcollectionDetails`;
	return makeApiCall(url, data);
};
/******************* GET DASHBOARD STAFF COLLECTION LIST END *********** */

/******************* GET DASHBOARD STAFF LOCATION LIST START *********** */
export const dashboardStaffLocationListCall = (listData: any) => {
	const data = {
		GetCompanyBasedOnStaffLocationToken: listData,
	};
	const url = `${API_URL}getCompanyBasedOnStaffLocation`;
	return makeApiCall(url, data);
};
/******************* GET DASHBOARD STAFF LOCATION LIST END *********** */

/******************* GET PARTICULAR DATE DEMAND LIST START *********** */
export const dashboardParticularDateDemandListCall = (listData: any) => {
	const data = {
		ParticularDateGroupDemandInfoToken: listData,
	};
	const url = `${API_URL}getParticularDateGroupDemandInfo`;
	return makeApiCall(url, data);
};
/******************* GET PARTICULAR DATE DEMAND LIST END *********** */

/******************* GET PARTICULAR DATE DEMAND MEMBER LIST START *********** */
export const dashboardParticularDateDemandMemberListCall = (listData: any) => {
	const data = {
		ParticularDateGroupMemberInfoToken: listData,
	};
	const url = `${API_URL}getParticularDateGroupMemberInfo`;
	return makeApiCall(url, data);
};
/******************* GET PARTICULAR DATE DEMAND MEMBER LIST END *********** */

/******************* GET MEMBER ABSENT LIST START *********** */
export const dashboardParticularDateMemberAbsentListCall = (listData: any) => {
	const data = {
		DashboardMemberAbsentDetailsToken: listData,
	};
	const url = `${API_URL}getMemberAbsentDueList`;
	return makeApiCall(url, data);
};
/******************* GET MEMBER ABSENT LIST END *********** */

/******************* GET PARTICULAR DATE COLLECTION LIST START *********** */
export const dashboardParticularDateCollectionListCall = (listData: any) => {
	const data = {
		DashboardParticularDateGroupCollectionToken: listData,
	};
	const url = `${API_URL}getParticularDateGroupCollectionInfo`;
	return makeApiCall(url, data);
};
/******************* GET PARTICULAR DATE COLLECTION LIST END *********** */

/******************* GET PARTICULAR DATE MEMBER COLLECTION LIST START *********** */
export const dashboardParticularMemberCollectionListCall = (listData: any) => {
	const data = {
		GetParticularDateGroupMemberCollectionToken: listData,
	};
	const url = `${API_URL}getParticularDateGroupMemberCollectionInfo`;
	return makeApiCall(url, data);
};
/******************* GET PARTICULAR DATE MEMBER COLLECTION LIST END *********** */

/******************* GET WEEK COLLECTION LIST START *********** */
export const dashboardWeekCollectionListCall = (listData: any) => {
	const data = {
		CollectionAmountBranchMemberWiseToken: listData,
	};
	const url = `${API_URL}getDashboardCollectionAmountBranchMemberWise`;
	return makeApiCall(url, data);
};
/******************* GET WEEK COLLECTION LIST END *********** */

/******************* GET WEEK YT COLLECTION LIST START *********** */
export const dashboardWeekYTCollectionListCall = (listData: any) => {
	const data = {
		GetParticularCollectionPendingGroupMemberToken: listData,
	};
	const url = `${API_URL}getParticularDateCollectionPendingGroupMemberInfo`;
	return makeApiCall(url, data);
};
/******************* GET WEEK YT COLLECTION LIST END *********** */

/******************* GET SMS USED LIST START *********** */
export const smsUsedListCall = (listData: any) => {
	const data = {
		DashboardSMSUsedListToken: listData,
	};
	const url = `${API_URL}dashboardSMSUsedListToken`;
	return makeApiCall(url, data);
};
/******************* GET SMS USED LIST END *********** */

/******************* GET KYC USED LIST START *********** */
export const kycUsedListCall = (listData: any) => {
	const data = {
		DashboardKYCUsedListToken: listData,
	};
	const url = `${API_URL}dashboardKYCUsedListToken`;
	return makeApiCall(url, data);
};
/******************* GET KYC USED LIST END *********** */

/******************* GET ARREAR COLLECTION LIST START *********** */
export const arrearCollectionListCall = (listData: any) => {
	const data = {
		DashboardArrearCollectionListToken: listData,
	};
	const url = `${API_URL}dashboardArrearCollectionListToken`;
	return makeApiCall(url, data);
};
/******************* GET ARREAR COLLECTION LIST END *********** */

/******************* GET DASHBOARD STAFF MAP COLLECTION LIST START *********** */
export const dashboardStaffMapCollectionCall = (listData: any) => {
	const data = {
		DashboardStaffMapCollectionToken: listData,
	};
	const url = `${API_URL}getOfficerGroupLoanListByDay`;
	return makeApiCall(url, data);
};
/******************* GET DASHBOARD STAFF MAP COLLECTION LIST END *********** */

/******************* GET DASHBOARD COLLECTION NOTE INFO START *********** */
export const dashboardCollectionNoteInfoCall = (listData: any) => {
	const data = {
		GetCollectionNotesInfoToken: listData,
	};
	const url = `${API_URL}getCollectionNotesInfo`;
	return makeApiCall(url, data);
};
/******************* GET DASHBOARD COLLECTION NOTE INFO END *********** */

/***************** Get Dashboard Savind And FD Details *******************/
export const getDashboardSavingsAndFDGet = (fetchData: any) => {
	const data = {
		getDashBoardSavingsAndFDToken: fetchData,
	};
	const url = `${API_URL}getDashboardSavingsAndFD`;
	return makeApiCall(url, data);
};
/*********** Get Dashboard Savind And FD Details ***************/
/***************** Get Dashboard Total Branch Member *******************/
export const getDashboardTotalBranchMemberGet = (fetchData: any) => {
	const data = {
		GetDashboardTotalBranchMemberToken: fetchData,
	};
	const url = `${API_URL}getDashboardTotalBranchMember`;
	return makeApiCall(url, data);
};
/*********** Get Dashboard Total Branch Member ***************/

/***************** Get Branch Total Investment Amount *******************/
export const getBranchTotalInvestmentAmountGet = (fetchData: any) => {
	const data = {
		GetBranchTotalInvestmentAmountToken: fetchData,
	};
	const url = `${API_URL}getBranchTotalInvestmentAmount`;
	return makeApiCall(url, data);
};
/*********** Get Branch Total Investment Amount ***************/

/***************** Get Branch Total OLB Amount *******************/
export const getBranchTotalOLBAmountGet = (fetchData: any) => {
	const data = {
		GetBranchTotalOLBAmountToken: fetchData,
	};
	const url = `${API_URL}getBranchTotalOLBAmount`;
	return makeApiCall(url, data);
};
/*********** Get Branch Total OLB Amount ***************/

/***************** Get Total Collection *******************/
export const getTotalCollectionGet = (fetchData: any) => {
	const data = {
		GetTotalCollectionAmountToken: fetchData,
	};
	const url = `${API_URL}getTotalCollection`;
	return makeApiCall(url, data);
};
/*********** Get Total Collection ***************/

export const getDashboardAmountBasedonlocationGet = (fetchData: any) => {
	const data = {
		GetDashboardDetailsBasedonLocToken: fetchData,
	};
	const url = `${API_URL}getDashboardAmountBasedonlocation`;
	return makeApiCall(url, data);
};

export const getDashboardZeroCollectionDetailsGet = (fetchData: any) => {
	const data = {
		getDashBoardZeroCollectionToken: fetchData,
	};
	const url = `${API_URL}getDashboardZeroCollectionDetails`;
	return makeApiCall(url, data);
};

export const getOnlineStaffDetailsGet = (fetchData: any) => {
	const data = {
		getOnlineStaffDetailsToken: fetchData,
	};
	const url = `${API_URL}getOnlineStaffDetails`;
	return makeApiCall(url, data);
};

export const getOfficerLiveStatusCall = (fetchData: any) => {
	const data = {
		GetOfficerLiveStatusToken: fetchData,
	};
	const url = `${API_URL}getOfficerLiveStatus`;
	return makeApiCall(url, data);
};

/******************* GET GOLD LOAN CARD DETAILS START *********** */
export const getGoldLoanCardDetailsGet = (listData: any) => {
	const data = {
		GetGoldLoanCardDetailsToken: listData,
	};
	const url = `${API_URL}getGoldLoanCardDetails`;
	return makeApiCall(url, data);
};
/******************* GET GOLD LOAN CARD DETAILS END *********** */

/******************* GET GOLD LOAN DASHBOARD LOAN DETAILS START *********** */
export const getGoldLoanDashboardLoanDetailsGet = (listData: any) => {
	const data = {
		GetGoldLoanDashboardLoanDetailsToken: listData,
	};
	const url = `${API_URL}getGoldLoanDashboardLoanDetails`;
	return makeApiCall(url, data);
};
/******************* GET GOLD LOAN DASHBOARD LOAN DETAILS END *********** */

/******************* GET GOLD LOAN LOAN INDEX DETAILS START *********** */
export const getGoldLoanLoanIndexDetailsGet = (listData: any) => {
	const data = {
		GetGoldLoanLoanIndexDetailsToken: listData,
	};
	const url = `${API_URL}getGoldLoanLoanIndexDetails`;
	return makeApiCall(url, data);
};
/******************* GET GOLD LOAN LOAN INDEX DETAILS END *********** */
